import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";
import {Link} from "react-router-dom";

export default () => {
    const title = 'Музей железнодорожной техники';

    const images = [
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt000.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m000.jpg'),
            description: 'Музей',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt001.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m001.jpg'),
            description: 'Вход',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt002.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m002.jpg'),
            description: 'План',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt003.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m003.jpg'),
            description: 'Открытие музея',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt004.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m004.jpg'),
            description: 'Рисунок Н. Орды',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt005.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m005.jpg'),
            description: 'паровоз Эу699 45',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt006.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m006.jpg'),
            description: 'паровоз Эу699 45',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt007.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m007.jpg'),
            description: 'паровоз Эу699 45',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt008.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m008.jpg'),
            description: 'паровоз Эу699 45',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt009.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m009.jpg'),
            description: 'паровоз Эр743 76',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt010.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m010.jpg'),
            description: 'паровоз Эр770-36',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt011.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m011.jpg'),
            description: 'паровоз Эр770-36',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt012.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m012.jpg'),
            description: 'паровоз Эр770-36',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt013.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m013.jpg'),
            description: 'паровоз Эр17-750-01',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt014.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m014.jpg'),
            description: 'паровоз Эр17-750-01',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt015.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m015.jpg'),
            description: 'паровоз Эр17-750-01',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt016.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m016.jpg'),
            description: 'паровоз ТЭ 8026',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt017.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m017.jpg'),
            description: 'паровоз ТЭ 8026',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt018.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m018.jpg'),
            description: 'паровоз ТЭ 8026',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt019.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m019.jpg'),
            description: 'паровоз ТЭ 8026',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt020.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m020.jpg'),
            description: 'паровоз ТЭ 074',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt021.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m021.jpg'),
            description: 'паровоз ТЭ 074',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt022.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m022.jpg'),
            description: 'паровоз ТЭ 2596',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt023.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m023.jpg'),
            description: 'паровоз ТЭ 2596',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt024.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m024.jpg'),
            description: 'паровоз ТЭ 2596',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt025.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m025.jpg'),
            description: 'паровоз ТЭ 5806',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt026.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m026.jpg'),
            description: 'паровоз ТЭ 5806',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt027.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m027.jpg'),
            description: 'паровоз ТЭ 5806',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt028.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m028.jpg'),
            description: 'паровоз ТЭ 5806',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt029.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m029.jpg'),
            description: 'паровоз ТЭ 5806',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt030.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m030.jpg'),
            description: 'паровоз СО17 3268',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt031.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m031.jpg'),
            description: 'паровоз СО17 3268',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt032.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m032.jpg'),
            description: 'паровоз СО17 3268',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt033.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m033.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt034.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m034.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt035.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m035.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt036.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m036.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt037.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m037.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt038.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m038.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt039.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m039.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt040.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m040.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt041.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m041.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt042.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m042.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt043.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m043.jpg'),
            description: 'паровоз Л0009',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt044.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m044.jpg'),
            description: 'паровоз Л1259',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt045.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m045.jpg'),
            description: 'паровоз Л1259',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt046.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m046.jpg'),
            description: 'Танк-паровоз 9П',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt047.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m047.jpg'),
            description: 'Танк-паровоз 9П',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt048.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m048.jpg'),
            description: 'Танк-паровоз 9П',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt049.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m049.jpg'),
            description: 'Танк-паровоз 9П',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt050.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m050.jpg'),
            description: 'тепловоз ТЭ1 20 165',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt051.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m051.jpg'),
            description: 'тепловоз ТЭ1 20 165',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt052.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m052.jpg'),
            description: 'тепловоз ТЭП60 0121',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt053.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m053.jpg'),
            description: 'тепловоз ТЭП60 0121',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt054.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m054.jpg'),
            description: 'тепловоз ТЭП60 0121',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt055.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m055.jpg'),
            description: 'тепловоз ТЭП60 0121',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt056.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m056.jpg'),
            description: 'тепловоз ЧМЭ2 209',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt057.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m057.jpg'),
            description: 'тепловоз ЧМЭ2 209',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt058.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m058.jpg'),
            description: 'тепловоз ТЭ3 6965',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt059.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m059.jpg'),
            description: 'тепловоз ТЭ3 6965',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt060.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m060.jpg'),
            description: 'тепловоз ТЭМ15 017',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt061.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m061.jpg'),
            description: 'тепловоз ТЭМ15 017',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt062.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m062.jpg'),
            description: 'тепловоз 2ТЭМ109 002',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt063.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m063.jpg'),
            description: 'тепловоз 2ТЭМ109 002',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt064.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m064.jpg'),
            description: 'тепловоз 2ТЭМ109 002',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt065.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m065.jpg'),
            description: 'тепловоз М62 1003',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt066.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m066.jpg'),
            description: 'паровой кран ПК ЦУМ315 490',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt067.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m067.jpg'),
            description: 'паровой кран ПК ЦУМ315 490',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt068.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m068.jpg'),
            description: 'паровой кран ПК-6 1158',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt069.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m069.jpg'),
            description: 'паровой кран ПК-6 115',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt070.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m070.jpg'),
            description: 'вагон-салон. Железнодорожный вагон, который, по легенде, служил теплушкой самому батьке Махно, приобрели сотрудники Брестского музея железнодорожной техники.',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt071.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m071.jpg'),
            description: 'вагон-салон',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt072.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m072.jpg'),
            description: 'вагон-салон',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt073.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m073.jpg'),
            description: 'вагон-салон',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt074.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m074.jpg'),
            description: 'вагон-салон',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt075.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m075.jpg'),
            description: 'вагон-салон',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt076.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m076.jpg'),
            description: 'вагон-салон',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt077.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m077.jpg'),
            description: 'вагон 4-осный',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt078.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m078.jpg'),
            description: 'вагон 4-осный',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt079.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m079.jpg'),
            description: 'вагон 2-осный',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt080.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m080.jpg'),
            description: 'вагон 2-осный',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt081.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m081.jpg'),
            description: 'вагон 2-осный пасс.',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt082.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m082.jpg'),
            description: 'вагон 2-осный пасс.',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt083.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m083.jpg'),
            description: 'платформа',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt084.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m084.jpg'),
            description: 'цистерна 2-осная',
        },
        {
            original: require('./../img/virtualtours/museumlocomotive/mzt085.jpg'),
            thumbnail: require('./../img/virtualtours/museumlocomotive/m085.jpg'),
            description: 'цистерна 4-осная',
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <div className="onehalf-col-cell">
                        <h2>{title}</h2>
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>

                <div className="pageitem">
                    <p className="sub">Брестский музей железнодорожной техники расположен недалеко от мемориального комплекса «Брестская крепость—герой».</p>
                    <p>Стараниями заслуженного железнодорожника, первого директора брестского музея Аркадия Приветеня здесь собрано более полусотни уникальных экспонатов локомотивов, вагонов и прочих железнодорожных агрегатов выпуска начала и середины прошлого века.</p>
                    <p>Первые паровозы были созданы в Великобритании в 1803 (Р. Тревитик) и в 1814 (Дж. Стефенсон). В России первый оригинальный паровоз был построен Е. А. и М. Е. Черепановыми (1833). Свыше столетия паровоз были самым распространённым видом тяги вплоть до 50-х годов 20 века, когда их повсеместно стали заменять электровозы и тепловозы. С 1956 выпуск паровозов в СССР был прекращен, хотя они ещё долго эксплуатировались на некоторых линиях железных дорог и на промышленных предприятиях. Основная причина замены паровозов другими видами локомотивов - его низкая экономичность: кпд лучших моделей не превышал 9%, среднеэксплуатационный кпд 4%.</p>
                    <p>Паровоз, один из видов локомотива,у которого двигателем является паровая машина. Основные элементы паровоза: паровой котёл, паровая машина, экипажная часть. Запасы топлива, воды и смазки помещаются обычно в прицепленном к паровозу тендере; если эти запасы находятся на самом паровозе, то такой локомотив называется танк-паровозом. В результате сгорания в топке котла топлива (каменный уголь, мазут, горючие сланцы, торф, дрова и др.) тепло через стенки топки, жаровых и дымогарных труб передаётся котловой воде, которая превращается в пар. Для повышения экономичности паровоза в специальных установках пар перегревается и его температура значительно повышается. Паровая машина преобразует тепловую энергию в механическую энергию движения поршня в паровых цилиндрах, через шатунно-кривошипный механизм это движение передаётся движущим колёсам. К экипажной части паровоза относятся рама, колёсные пары с буксами, бегунковые и поддерживающие тележки (с одной или двумя колёсными парами), рессорное подвешивание, а также аппараты сцепления.</p>
                    <p>Употребительнейшие типы паровозов следующие: 1) курьерские - для поездов весом 75-150 тонн и скоростью 60-90 км. в час; 2) пассажирские - для поездов 100-250 тонн и скоростью 35-60 км. в час; 3) товарные для поездов 250-700 тонн и скоростью 20-30 км в час.</p>
                </div>

                <div className="pageitem">
                    <ul>
                        <li><Link to='/topic-locomotive-EU699-45'>Паровоз Эу699 45</Link></li>
                        <li><Link to='/topic-locomotive-ER770-36'>Паровоз Эр770-36</Link></li>
                        <li><Link to='/topic-locomotive-ER17-750-01'>Паровоз Эр17-750-01</Link></li>
                        <li><Link to='/topic-locomotive-TE8026'>Паровоз ТЭ 8026</Link></li>
                        <li><Link to='/topic-locomotive-TE074'>Паровоз ТЭ 8074</Link></li>
                        <li><Link to='/topic-locomotive-TE2596'>Паровоз ТЭ 2596</Link></li>
                        <li><Link to='/topic-locomotive-TE5806'>Паровоз ТЭ 5806</Link></li>
                        <li><Link to='/topic-locomotive-CO17-3268'>Паровоз СО17 3268</Link></li>
                        <li><Link to='/topic-locomotive-L0009'>Паровоз Л0009</Link></li>
                        <li><Link to='/topic-locomotive-L1259'>Паровоз Л1259</Link></li>
                        <li><Link to='/topic-locomotive-tank-9P'>Танк-паровоз 9П</Link></li>
                        <li><Link to='/topic-locomotive-TE1-20-165'>Тепловоз ТЭ1 20 165</Link></li>
                        <li><Link to='/topic-locomotive-TEP60-0121'>Тепловоз ТЭП60 0121</Link></li>
                        <li><Link to='/topic-locomotive-CME2-209'>Тепловоз ЧМЭ2 209</Link></li>
                        <li><Link to='/topic-locomotive-TEZ-6965'>Тепловоз ТЭ3 6965</Link></li>
                        <li><Link to='/topic-locomotive-TEM15-017'>Тепловоз ТЭМ15 017</Link></li>
                        <li><Link to='/topic-locomotive-2TEM109-002'>Тепловоз 2ТЭМ109 002</Link></li>
                        <li><Link to='/topic-locomotive-M62-1003'>Тепловоз М62 1003</Link></li>
                        <li><Link to='/topic-locomotive-cranes'>Паровые краны</Link></li>
                        <li><Link to='/topic-locomotive-wagons'>Вагоны</Link></li>
                        <li><Link to='/topic-locomotive-platform'>Платформа</Link></li>
                        <li><Link to='/topic-locomotive-cisterns'>Цистерны</Link></li>
                    </ul>
                </div>

                <div className="pageitem">
                    <div className="sub">Андрей НЕКРАСОВ, «Советская Белоруссия», 24 июня 2003 года</div>
                    <p>Брестский музей железнодорожной техники расположен очень выгодно: на центральном проспекте города, в 10 — 15 минутах ходьбы от центра и буквально в двух шагах от главного входа в мемориальный комплекс «Брестская крепость—герой». Впрочем, даже если бы железнодорожную экспозицию год назад — в мае 2002-го — развернули где-нибудь на окраине, популярности ей это вряд ли бы убавило. Собранная здесь коллекция паровозов, локомотивов, вагонов и прочих железнодорожных агрегатов выпуска начала и середины прошлого века общим числом более 50 штук без преувеличения уникальна. Ближайшая столь же богатая и интересная экспозиция, по словам директора брестского музея Аркадия Привитеня, находится в Санкт-Петербурге.</p>
                    <p>Коллекция напоминает застывший парад. Все экспонаты — внушительных, размеров машины весом в сотни тонн каждая — стоят несколькими колоннами, сверкая свежевыкрашенными бока­ми. Паровозам тут в среднем по полстолетия, а самый старый музейный трофей — тип 0-5-0 серии «Эу» — впервые стал на рельсы три четверти века назад</p>
                    <p>И ведь где только не собирал Аркадий Привитень свою коллекцию! В начале 70-х годов, когда тепловозы начали повсеместно вытеснять паровозы, которым высокое начальство постановило закончить свой век в сталеплавильных печах Владимирского металлургического завода, он работал начальником базы локо­мотивов в депо станции «Брест». Признается, что сам отправил на переплавку не один десяток машин. Однако ближе к пенсии Аркадий Викторович стал подумывать не столько о выполнении планов по уничтожению старой техники, сколько о том, чтобы сохранить хоть что-нибудь для будущих поколений.</p>
                    <p>Инициатива была сугубо частной, никто из тогдашних руководителей Брестского отделения Белорусской железной дороги ее не поощрял и, конечно, содействия Аркадию Привитеню не оказывал. А он принялся ездить по всему бывшему Союзу — в свободное время и очень часто за собственный счет, — разыскивая сохранившиеся паровозы и первые тепловозы редких серий, договариваясь с начальниками станций о том, чтобы машины передали в Брест.</p>
                    <p>Несколько паровозов Аркадий Викторович взял в Ленинграде, два привез из Ростова. Многое удалось собрать пря­мо в Беларуси. Однажды пришлось в течение 16 дней гнать из Питера тепловоз — первая советская модель! — в 20-градусную стужу. Тащили на буксире. Если участок пути был особенно напряженным, тепловоз надолго ставили в тупик, приходилось ждать часами, а то и сутками. Все это время Аркадий Привитень с помощником находились в кабине перегоняемого локомотива, грелись у печки-«буржуйки». Кстати, машина та была из серии, почтенный, представитель которой возил Сталина на Потсдамскую конференцию.</p>
                    <p>Зачастую брестскому энтузиасту передавали локомотивы и вагоны, долгое время стоявшие и ветшавшие на заросших бурьяном запасных путях, угольных складах и в других Богом забытых местах в ожидании отправки во Владимир. Зато теперь многие паровозы из коллекции Аркадия Викторовича, будучи полностью восстановленными, вполне могут одолеть дистанцию в тысячу и более километров. Весной этого года, в канун Дня Победы, паровоз знаменитой серии «П-36» — к слову, тоже «Победа» — во­зил состав с ветеранами войны и труда по маршруту Минск — Брест. А до того целых 18 дней отработал в Украине, где катал по Карпатам и Крыму богатых туристов из Германии, Англии, Японии и Соединенных Штатов. Предоставляя «Победу» во временное пользование украинскому предпринимателю, владельцу собственного ретро-поезда, музей пытается заработать валюту для Брестского отделения БЖД и тем самым отчасти компенсировать расходы на собственное содержание. Ретро-поезд — это один из коммерчески наиболее удачных проектов, реализовнных нашими украинскими соседями в сфере иностранного туризма. Речь идет о составе из старинных вагонов, качественно отреставрированных и оснащенных современными «наворотами», в которых богатая публика с превеликим удовольствием путешествует по живописным маршрутам, воображая себя утонченными аристократами прошлого. В Украине есть такой поезд, однако нет подобающего локомотива.</p>
                    <p>Интуристы, как утверждает Аркадий Викторович, прекрасно ориентируются в сериях советских паровозов и если уж тратят деньги, то желают все иметь по высшему разряду. «Победа», кстати, хоть и паром движима, но скорость развивает до 125 километров в час!</p>
                    <p>Таких паровозов в исправном состоянии сейчас на постсоветском пространстве остались единицы. Недаром украинцы зависят в этом отношении от брестчан — не говоря уже о том, что содержание и техническое обслуживание паровоза нынче представляют собой отдельную большую проблему. Мало того, что запчастей днем с огнем не сыскать — их просто почти не осталось, так еще и бригаду (машиниста, помощника машиниста и кочегара), способную управлять старой техникой, собрать становится все труднее. Те, кто водил паровозы, нынче в основном уже на пенсии. Отправляя последний раз «П-36» в Карпаты и Крым, Аркадий Привитень сумел обеспечить всего две бригады. Людей подобрал не­молодых, а ведь рабочий график у них очень напряженный: смена длится 12 часов, затем сутки отдыха.</p>
                    <p>Однако раз уж мы все-таки имеем и паровозы, и машинистов — подготовить новые кадры, в конце концов, возможно, — руководство Брестского отделения БЖД приняло решение создать собственный ретро-поезд. Директор музея, говоря о сроках, надеется, что первый белорусский коммерческий ретро-состав отправится в рейс этим летом.</p>
                    <p>Подходящие вагоны сейчас делает Гомельский вагоноремонтный завод. Пробный пуск такого поезда уже состоялся — приуроченный к 9 Мая рейс для ветеранов. Разработаны варианты маршрутов по Беларуси. Денежную клиентуру, как показывает украинский опыт, найти несложно...</p>
                    <p>Что осталось? Наверное, еще масса чисто технических мелочей. Случается, правда, что именно они и хоронят толковую идею. Впрочем, давно пора эту старую печальную традицию нарушить.</p>
                </div>
            </div>
        </>
    );
}